"use strict";
/**
 * Created by Ning Jiang on 11/24/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespinZeroBetController = void 0;
const GameMode_1 = require("../../core/gamemode/GameMode");
const ZeroBetController_1 = require("../../core/zerobet/ZeroBetController");
class RespinZeroBetController extends ZeroBetController_1.ZeroBetController {
    constructor() {
        super();
    }
    getZeroBetNumberLeft(data) {
        return -1;
    }
    shouldSubtractZeroBetCounter() {
        return false;
    }
    shouldShowZeroBetCounter() {
        return false;
    }
    calculateIsTriggered(data) {
        return data.nextMode === GameMode_1.GameMode.RESPIN;
    }
}
exports.RespinZeroBetController = RespinZeroBetController;
//# sourceMappingURL=RespinZeroBetController.js.map